import {
  Button,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
} from "@material-ui/core";
import FolderIcon from "@material-ui/icons/Folder";
import React, { useEffect, useState } from "react";
import { generatePath, Link } from "react-router-dom";
import RelativeDate from "../components/RelativeDate";
import API from "../api";
import { useResource } from "../useResource";
import { projectPagePath } from "./ProjectPage";
import { Add, Delete } from "@material-ui/icons";
import ConfirmDialog from "../components/ConfirmDialog";
import { Project } from "../_generated";
import { OwnProjectEditDialog } from "./ProjectEditDialog";
import analytics from "../analytics";

export default function ProjectListPage() {
  const [projects] = useResource(API.projects.list);

  const [confirmName, setConfirmName] = useState("");
  const [showOwnProjectCreateDialog, setOwnProjectShowCreateDialog] = useState(
    false
  );

  function onOwnProjectCreate(project: Project) {
    API.projects.create(project).then((response: any) => {
      window.location.href = `#/projects/${response.name}/services`;
    });
    setOwnProjectShowCreateDialog(false);
  }

  function onDeleteConfirm(name: string) {
    setConfirmName("");
    API.projects.delete(name);
  }

  useEffect(() => {
    analytics.page("ProjectList");
  }, []);

  return (
    <>
      <Grid container justify="center">
        <Grid item xs={12} md={6}>
          <Paper variant="outlined">
            <List>
              {projects.map((project) => (
                <ListItem
                  button
                  component={Link}
                  to={generatePath(projectPagePath, {
                    project_name: project.name,
                  })}
                  key={project.name}
                >
                  <ListItemIcon>
                    <FolderIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={project.alias || project.name}
                    secondary={
                      <>
                        Created <RelativeDate date={project.date_created} />
                      </>
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      onClick={() => setConfirmName(project.name)}
                    >
                      <Delete />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}

              <ListItem>
                <Button
                  startIcon={<Add />}
                  variant="outlined"
                  style={{ flexGrow: 1 }}
                  onClick={() => setOwnProjectShowCreateDialog(true)}
                >
                  Add project (Your own account)
                </Button>
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>

      <ConfirmDialog
        open={confirmName !== ""}
        id={confirmName}
        onCancel={() => setConfirmName("")}
        onConfirm={(id) => onDeleteConfirm(id)}
        text="This will delete the project and remove all deployed components from the cloud. Do you want to proceed?"
      />

      <OwnProjectEditDialog
        open={showOwnProjectCreateDialog}
        onSubmit={onOwnProjectCreate}
        onCancel={() => setOwnProjectShowCreateDialog(false)}
      />
    </>
  );
}
